export const JustNumber = (value: string) => {
  const numericValue = value.replace(/[^0-9]/g, "");

  return numericValue;
};
